import {
  METADATA_SET_CATEGORIZED_METADATA_SETS_READ,
  METADATA_SET_CATEGORY_SELECT,
  METADATA_SET_CONCEPT_SCHEMES_READ,
  METADATA_SET_IMPORT_REPORTS_CLEAR,
  METADATA_SET_IMPORT_REPORTS_FILE_UPLOAD,
  METADATA_SET_IMPORT_REPORTS_SUBMIT,
  METADATA_SET_METADATA_SET_CATEGORISE,
  METADATA_SET_METADATA_SET_CHANGE,
  METADATA_SET_METADATA_SET_CLONE_CHANGE,
  METADATA_SET_METADATA_SET_CLONE_HIDE,
  METADATA_SET_METADATA_SET_CLONE_SHOW,
  METADATA_SET_METADATA_SET_CLONE_SUBMIT,
  METADATA_SET_METADATA_SET_CREATE,
  METADATA_SET_METADATA_SET_DELETE,
  METADATA_SET_METADATA_SET_HTML_PAGE_HIDE,
  METADATA_SET_METADATA_SET_HTML_PAGE_SHOW,
  METADATA_SET_METADATA_SET_READ,
  METADATA_SET_METADATA_SET_SELECT,
  METADATA_SET_METADATA_SET_SUBMIT,
  METADATA_SET_METADATAFLOW_SET,
  METADATA_SET_METADATAFLOW_UNSET,
  METADATA_SET_METADATAFLOWS_HIDE,
  METADATA_SET_METADATAFLOWS_READ,
  METADATA_SET_METADATAFLOWS_SHOW,
  METADATA_SET_REPORT_ATTRIBUTE_ATTACHMENT_UPLOAD,
  METADATA_SET_REPORT_ATTRIBUTE_CHANGE,
  METADATA_SET_REPORT_ATTRIBUTE_CODE_SET,
  METADATA_SET_REPORT_ATTRIBUTE_CODE_UNSET,
  METADATA_SET_REPORT_ATTRIBUTE_CODES_HIDE,
  METADATA_SET_REPORT_ATTRIBUTE_CODES_READ,
  METADATA_SET_REPORT_ATTRIBUTE_CODES_SHOW,
  METADATA_SET_REPORT_ATTRIBUTE_CREATE,
  METADATA_SET_REPORT_ATTRIBUTE_DELETE,
  METADATA_SET_REPORT_ATTRIBUTE_SELECT,
  METADATA_SET_REPORT_CLONE_SUBMIT,
  METADATA_SET_REPORT_CREATE,
  METADATA_SET_REPORT_DELETE,
  METADATA_SET_REPORT_HIDE,
  METADATA_SET_REPORT_HTML_PAGE_HIDE,
  METADATA_SET_REPORT_HTML_PAGE_SHOW,
  METADATA_SET_REPORT_ID_CHANGE,
  METADATA_SET_REPORT_READ,
  METADATA_SET_REPORT_STEP_SET,
  METADATA_SET_REPORT_SUBMIT,
  METADATA_SET_REPORT_TARGET_ARTEFACT_SET,
  METADATA_SET_REPORT_TARGET_ARTEFACT_UNSET,
  METADATA_SET_REPORT_TARGET_ARTEFACTS_HIDE,
  METADATA_SET_REPORT_TARGET_ARTEFACTS_READ,
  METADATA_SET_REPORT_TARGET_ARTEFACTS_SHOW,
  METADATA_SET_REPORT_TARGET_SELECT,
  METADATA_SET_UPDATE_REPORT_STATE_SUBMIT
} from "./actions";
import {REQUEST_ERROR, REQUEST_SUCCESS} from '../../../middlewares/api/actions';
import {
  CATEGORY_SCHEME_ORDER_ANNOTATION_KEY,
  getArtefactFromSdmxJsonStructure,
  getArtefactTripletFromUrn,
  getItemFromSdmxJsonStructure,
  getItemSchemeFromSdmxJsonFactory,
  getSdmxStructuresFromSdmxJson,
  getStringFromArtefactTriplet,
  getUrnFromArtefact,
  getUrnFromArtefactTriplet,
  SDMX_JSON_CATEGORISATION_LIST_KEY,
  SDMX_JSON_CATEGORY_SCHEME_LIST_KEY,
  SDMX_JSON_CODELIST_ITEMS_KEY,
  SDMX_JSON_CONCEPT_SCHEME_ITEMS_KEY,
  SDMX_JSON_METADATAFLOW_URN_NAMESPACE
} from "../../../utils/sdmxJson";
import {getCategorisedObjectsTree, getFilteredTree, getMappedTree, getNode} from "../../../utils/tree";
import _ from "lodash";
import uuidv4 from 'uuid';
import {
  EMPTY_REPORT_ATTRIBUTE_KEY,
  getDbIdAnnotationFromAnnotations,
  getMetadataflowTripletFromAnnotations,
  getMsdTree,
  getNextAttributeIndexAvailable,
  getReportStructureFromSdmxJsonReport,
  getTargetReferenceValuesStr,
  METADATA_SET_ID_ANNOTATION_ID,
  REPORT_STATE_NAME_ANNOTATION_ID,
  REPORT_STATE_PUBLISHED
} from "../../../utils/referenceMetadata";
import {getCurrentNodeConfig} from "../../../middlewares/current-node-config/middleware";
import {getOrderedChildren} from "../../../utils/artefacts";
import {
  AGENCY_PERMISSION_MISSING,
  ARTEFACT_TYPES,
  customIsReferenceMetadataAutoAnnotation,
  REPORT_DETAILS_WIZARD_STEP_FIRST,
  REPORT_DETAILS_WIZARD_STEP_SECOND
} from "../commons/constants";
import {getCurrentUserPermissions} from "../../../middlewares/current-user-permissions/middleware";

const metadataSetReducer = (
  state = {
    categorySchemes: null,
    categorisations: null,
    categoryId: null,
    categoryUrn: null,
    metadataSets: null,
    metadataSetTree: null,
    metadataSetId: null,
    metadataSetCategory: null,
    msdTriplet: null,
    metadataSet: null,
    hasPermission: false,
    metadataflows: null,
    isMetadataflowsVisible: false,
    msd: null,
    msdTree: null,
    report: null,
    isReportVisible: false,
    reportStructure: null,
    selectedAttribute: null,
    step: null,
    isCodesVisible: false,
    codes: null,
    reportId: null,
    target: null,
    identifiableTargets: null,
    selectedIdentifiableTarget: null,
    artefacts: null,
    isFetchMetadataSetDisabled: true,
    reportHtmlPageUrl: null,
    conceptSchemeTriplets: null,
    conceptSchemes: null,
    isCloneVisible: false,
    cloneId: null,
    metadataSetHtmlPageUrl: null,
    reportAnnotations: null,
    uploadedFileHash: null,
    uploadedReports: null,
    importedReports: null
  },
  action
) => {
  switch (action.type) {
    case METADATA_SET_CATEGORY_SELECT:
      return {
        ...state,
        categoryId: action.categoryId,
        categoryUrn: action.categoryUrn,
        metadataSet: null,
        conceptSchemeTriplets: null
      };
    case METADATA_SET_METADATA_SET_SELECT:
      return {
        ...state,
        metadataSetId: action.metadataSet ? action.metadataSet.id : null,
        metadataSetCategory: action.metadataSet ? action.metadataSet.categoryUrn : null,
        msdTriplet: action.msdTriplet,
        metadataSet: action.metadataSetId !== state.metadataSetId ? null : state.metadataSet,
        isFetchMetadataSetDisabled: false
      };
    case METADATA_SET_METADATA_SET_CREATE:
      return {
        ...state,
        hasPermission: true,
        metadataSet: {
          id: null,
          name: null,
          metadataflowTriplet: null,
          msdUrn: null,
          reportingBegin: null,
          reportingEnd: null,
          validFrom: null,
          validTo: null,
          publicationYear: null,
          publicationPeriod: null
        }
      };
    case METADATA_SET_METADATA_SET_CHANGE: {
      const metadataSet = _.cloneDeep(state.metadataSet);
      const customizer = (_, src, key) => {
        if (key === "annotations")
          return src;
        else {
          return undefined
        }
      };

      return {
        ...state,
        metadataSet: _.mergeWith(metadataSet, action.fields, customizer)
      };
    }
    case METADATA_SET_METADATAFLOWS_SHOW:
      return {
        ...state,
        isMetadataflowsVisible: true
      };
    case METADATA_SET_METADATAFLOWS_HIDE:
      return {
        ...state,
        isMetadataflowsVisible: false,
        metadataflows: null
      };
    case METADATA_SET_METADATAFLOW_SET:
      return {
        ...state,
        isMetadataflowsVisible: false,
        metadataflows: null,
        metadataSet: {
          ...state.metadataSet,
          msdUrn: action.msdUrn,
          metadataflowTriplet: action.triplet
        }
      };
    case METADATA_SET_METADATAFLOW_UNSET:
      return {
        ...state,
        metadataSet: {
          ...state.metadataSet,
          metadataflowTriplet: null,
          msdUrn: null
        }
      };
    case METADATA_SET_REPORT_CREATE: {
      return {
        ...state,
        isReportVisible: true,
        step: REPORT_DETAILS_WIZARD_STEP_FIRST
      };
    }
    case METADATA_SET_REPORT_HIDE:
      return {
        ...state,
        report: null,
        isReportVisible: false,
        reportStructure: null,
        selectedAttribute: null,
        step: null,
        reportId: null,
        target: null,
        identifiableTargets: null,
        reportAnnotations: null
      };
    case METADATA_SET_REPORT_HTML_PAGE_SHOW:
      return {
        ...state,
        reportHtmlPageUrl: action.htmlPageUrl
      };
    case METADATA_SET_REPORT_HTML_PAGE_HIDE:
      return {
        ...state,
        reportHtmlPageUrl: null
      };
    case METADATA_SET_REPORT_STEP_SET: {
      let reportStructure = (action.step === REPORT_DETAILS_WIZARD_STEP_SECOND && state.reportStructure === null)
        ? getReportStructureFromSdmxJsonReport(state.msdTree, state.target, state.report, action.dataLanguages, action.t, getCurrentNodeConfig(action).annotations, getCurrentUserPermissions(action))
        : state.reportStructure;

      return {
        ...state,
        step: action.step,
        reportStructure: reportStructure,
        selectedAttribute: null
      };
    }
    case METADATA_SET_REPORT_ATTRIBUTE_SELECT: {
      const reportStructure = _.cloneDeep(state.reportStructure);
      const selectedAttribute = action.selectedAttributeKey
        ? getNode(reportStructure, "metadataAttributes", node => node.nodeKey === action.selectedAttributeKey)
        : null;

      return {
        ...state,
        selectedAttribute: selectedAttribute
      };
    }
    case METADATA_SET_REPORT_ATTRIBUTE_CHANGE: {
      const reportStructure = _.cloneDeep(state.reportStructure);
      let selectedAttribute = getNode(reportStructure, "metadataAttributes", node =>
        node.nodeKey === state.selectedAttribute.nodeKey);

      const customizer = (_, src, key) => {
        if (key === "annotations")
          return src;
        else {
          return undefined
        }
      };

      selectedAttribute = _.mergeWith(selectedAttribute, action.fields, customizer);

      return {
        ...state,
        reportStructure: reportStructure,
        selectedAttribute: selectedAttribute
      };
    }
    case METADATA_SET_REPORT_ATTRIBUTE_CREATE: {
      let reportStructure = _.cloneDeep(state.reportStructure);
      const selectedFolder = getNode(reportStructure, "metadataAttributes", node =>
        node.nodeKey === state.selectedAttribute.nodeKey);

      let node = _.cloneDeep(getNode(state.msdTree, "metadataAttributes", node =>
        node.id === (EMPTY_REPORT_ATTRIBUTE_KEY + state.selectedAttribute.id)));
      node = getMappedTree([node], "metadataAttributes", node => ({...node, nodeKey: uuidv4()}))[0];

      selectedFolder.metadataAttributes.push({
        ...node,
        isFolder: null,
        id: `${getNextAttributeIndexAvailable(selectedFolder.metadataAttributes)}. ${selectedFolder.id}`,
        name: `${getNextAttributeIndexAvailable(selectedFolder.metadataAttributes)}. ${selectedFolder.name}`,
        nodeKey: uuidv4(),
        texts: null
      });

      return {
        ...state,
        reportStructure: getFilteredTree(reportStructure, "metadataAttributes", node =>
          !node.id.includes(EMPTY_REPORT_ATTRIBUTE_KEY)),
        selectedAttribute: selectedFolder
      };
    }
    case METADATA_SET_REPORT_ATTRIBUTE_DELETE:
      let reportStructure = _.cloneDeep(state.reportStructure);
      const parentAttribute = getNode(reportStructure, "metadataAttributes", node =>
        node.metadataAttributes.find(child => child.nodeKey === state.selectedAttribute.nodeKey));
      parentAttribute.metadataAttributes = parentAttribute.metadataAttributes.filter(child =>
        child.nodeKey !== state.selectedAttribute.nodeKey);

      return {
        ...state,
        reportStructure: reportStructure,
        selectedAttribute: null
      };
    case METADATA_SET_REPORT_ATTRIBUTE_CODES_SHOW:
      return {
        ...state,
        isCodesVisible: true
      };
    case METADATA_SET_REPORT_ATTRIBUTE_CODES_HIDE:
      return {
        ...state,
        isCodesVisible: false,
        codes: null
      };
    case METADATA_SET_REPORT_ATTRIBUTE_CODE_SET: {
      const reportStructure = _.cloneDeep(state.reportStructure);

      const selectedCode = state.codes.find(code => code.id === action.codeId);

      const selectedAttribute = getNode(reportStructure, "metadataAttributes", node =>
        node.nodeKey === state.selectedAttribute.nodeKey);
      selectedAttribute.texts = selectedCode.name;

      return {
        ...state,
        isCodesVisible: false,
        codes: null,
        reportStructure: reportStructure,
        selectedAttribute: selectedAttribute
      };
    }
    case METADATA_SET_REPORT_ATTRIBUTE_CODE_UNSET: {
      const reportStructure = _.cloneDeep(state.reportStructure);
      const selectedAttribute = getNode(reportStructure, "metadataAttributes", node =>
        node.nodeKey === state.selectedAttribute.nodeKey);
      selectedAttribute.texts = null;

      return {
        ...state,
        reportStructure: reportStructure,
        selectedAttribute: selectedAttribute
      };
    }
    case METADATA_SET_REPORT_ID_CHANGE: {
      const newVal = action.id;
      const oldVal = state.reportId;

      return {
        ...state,
        reportId: newVal
          ? _.toUpper(/^[a-zA-Z0-9_]*$/.test(newVal) ? newVal : oldVal)
          : newVal,
      }
    }
    case METADATA_SET_REPORT_TARGET_SELECT: {
      const msdTree = _.cloneDeep(state.msdTree);

      return {
        ...state,
        target: action.target,
        identifiableTargets: msdTree.find(msd => msd.target === action.target).identifiableTargets,
        reportStructure: null,
        selectedAttribute: null
      }
    }
    case METADATA_SET_REPORT_TARGET_ARTEFACTS_SHOW:
      return {
        ...state,
        selectedIdentifiableTarget: action.identifiableTarget
      };
    case METADATA_SET_REPORT_TARGET_ARTEFACTS_HIDE:
      return {
        ...state,
        selectedIdentifiableTarget: null,
        artefacts: null
      };
    case METADATA_SET_REPORT_TARGET_ARTEFACT_SET: {
      const identifiableTargets = _.cloneDeep(state.identifiableTargets);

      const identifiableTargetId = action.identifiableTargetId ? action.identifiableTargetId : state.selectedIdentifiableTarget.id;
      const identifiableTarget = identifiableTargets.find(({id}) => id === identifiableTargetId);

      if (state.selectedIdentifiableTarget) {
        const urnNamespace = ARTEFACT_TYPES.find(({type}) => type === state.selectedIdentifiableTarget.objectType.toLowerCase()).urnNamespace;
        identifiableTarget.value = getUrnFromArtefactTriplet(action.value, urnNamespace);
      } else {
        identifiableTarget.value = action.value;
      }

      return {
        ...state,
        selectedIdentifiableTarget: null,
        identifiableTargets: identifiableTargets,
        artefacts: null
      };
    }
    case METADATA_SET_REPORT_TARGET_ARTEFACT_UNSET: {
      const identifiableTargets = _.cloneDeep(state.identifiableTargets);
      identifiableTargets.find(value => value.id === action.identifiableTarget.id).value = null;

      return {
        ...state,
        identifiableTargets: identifiableTargets
      };
    }
    case METADATA_SET_METADATA_SET_CLONE_SHOW:
      return {
        ...state,
        isCloneVisible: true
      };
    case METADATA_SET_METADATA_SET_CLONE_HIDE:
      return {
        ...state,
        isCloneVisible: false,
        cloneId: null
      };
    case METADATA_SET_METADATA_SET_CLONE_CHANGE:
      return {
        ...state,
        cloneId: action.fields.cloneId
      };
    case METADATA_SET_METADATA_SET_HTML_PAGE_SHOW:
      return {
        ...state,
        metadataSetHtmlPageUrl: action.htmlPageUrl
      };
    case METADATA_SET_METADATA_SET_HTML_PAGE_HIDE:
      return {
        ...state,
        metadataSetHtmlPageUrl: null
      };
    case METADATA_SET_IMPORT_REPORTS_CLEAR:
      return {
        ...state,
        uploadedReports: null,
        importedReports: null
      };
    case REQUEST_SUCCESS:
      switch (action.label) {
        case METADATA_SET_CATEGORIZED_METADATA_SETS_READ: {

          // gets ordered categoryScheme tree from server response
          const categorySchemes =
            (getSdmxStructuresFromSdmxJson(action.response[0], SDMX_JSON_CATEGORY_SCHEME_LIST_KEY) || [])
              .map(artefact => {
                let categoryScheme = {
                  ...getArtefactFromSdmxJsonStructure(artefact, getCurrentNodeConfig(action).annotations),
                  categories: (artefact.categories || []),
                  type: "categoryScheme",
                  urn: getUrnFromArtefact(artefact)
                };
                categoryScheme.categories = getMappedTree(
                  categoryScheme.categories,
                  "categories",
                  category => ({
                    ...getItemFromSdmxJsonStructure(category, getCurrentNodeConfig(action).annotations, CATEGORY_SCHEME_ORDER_ANNOTATION_KEY),
                    type: "category",
                    urn: getUrnFromArtefact(category)
                  })
                );

                return getMappedTree(
                  [categoryScheme],
                  "categories",
                  node => {
                    node.categories = getOrderedChildren(
                      node.categories,
                      node.id,
                      action.lang,
                      getCurrentNodeConfig(action).annotations[CATEGORY_SCHEME_ORDER_ANNOTATION_KEY]
                    );
                    return node
                  }
                )[0];
              });

          // gets categorisations
          const categorisations =
            (getSdmxStructuresFromSdmxJson(action.response[0], SDMX_JSON_CATEGORISATION_LIST_KEY) || [])
              .map(artefact => getArtefactFromSdmxJsonStructure(artefact, getCurrentNodeConfig(action).annotations));

          // gets metadataSet list from server response
          const metadataSets = (getSdmxStructuresFromSdmxJson(action.response[1]) || [])
            .map(ms => getArtefactFromSdmxJsonStructure(ms, null, customIsReferenceMetadataAutoAnnotation))
            .filter(({msdUrn}) => msdUrn !== getCurrentNodeConfig(action).dcatapit.msd)
            .map(metadataSet => {
              const metadataflowTriplet = getMetadataflowTripletFromAnnotations(metadataSet);
              return {
                ...metadataSet,
                type: "metadataSet",
                categorisations: categorisations
                  .filter(({source}) => source === getUrnFromArtefactTriplet(metadataflowTriplet, SDMX_JSON_METADATAFLOW_URN_NAMESPACE))
                  .map(categorisation => ({
                    id: categorisation.id,
                    agencyID: categorisation.agencyID,
                    version: categorisation.version,
                    source: categorisation.source,
                    target: categorisation.target
                  })),
                metadataflowTriplet: metadataflowTriplet
              };
            });

          // utility to test if a metadataSet belongs to a specific category
          const checkIfMetadataSetBelongsToCategory = (metadataSet, category) => {
            if (category) {
              return category.type === "category"
                ? metadataSet.categorisations.find(categorisation => categorisation.target === category.urn)
                : false;
            } else {
              return metadataSet.categorisations.length > 0;
            }
          };

          // building category tree with metadataSet
          let metadataSetTree = getCategorisedObjectsTree(
            metadataSets,
            categorySchemes,
            'categories',
            (a, b) => a.id - b.id,
            checkIfMetadataSetBelongsToCategory,
            'id',
            'name',
            false,
            true
          );

          // iterates on tree adding "categoryUrn" and "parent" to all node in the tree
          metadataSetTree = metadataSetTree.map(metadataSet => {
            metadataSet.categories = getMappedTree(metadataSet.categories, "categories", node => {
              if (node.urn && node.categories) {
                node.categories = node.categories.map(child => ({...child, categoryUrn: node.urn, parent: node.id}));
              }
              return node
            });
            return metadataSet
          });

          // iterates on tree adding unique key to all node in the tree
          metadataSetTree = getMappedTree(metadataSetTree, "categories", node => ({
            ...node,
            nodeKey: node.type !== "metadataSet"
              ? `${node.urn}+${node.id}`
              : `cat_${node.categoryUrn}+${node.id}`
          }));

          return {
            ...state,
            categorySchemes: categorySchemes,
            categorisations: categorisations,
            metadataSets: metadataSets,
            metadataSetTree: metadataSetTree
          };
        }
        case METADATA_SET_METADATA_SET_READ: {

          const userPermissions = getCurrentUserPermissions(action);
          const customNoneIsAutoAnnotation = userPermissions && userPermissions.rules.includes("CanManageWorkingAnnotation")
            ? () => false
            : undefined;

          const metadataSet = getArtefactFromSdmxJsonStructure(
            getSdmxStructuresFromSdmxJson(action.response[0])[0],
            null,
            customNoneIsAutoAnnotation || customIsReferenceMetadataAutoAnnotation
          );

          const metadataSetNode = getNode(state.metadataSetTree, "categories", node =>
            node.type === "metadataSet" && node.id === state.metadataSetId && (!node.categoryUrn || node.categoryUrn === state.metadataSetCategory));

          const msd = getArtefactFromSdmxJsonStructure(getSdmxStructuresFromSdmxJson(action.response[1])[0]);

          const conceptSchemeTriplets = [];
          msd.metadataStructureComponents.reportStructures.map(tree =>
            getMappedTree(tree.metadataAttributes, "metadataAttributes", node => {

              if (!conceptSchemeTriplets.find(triplet =>
                getStringFromArtefactTriplet(triplet) === getStringFromArtefactTriplet(getArtefactTripletFromUrn(node.conceptIdentity)))) {
                conceptSchemeTriplets.push(getArtefactTripletFromUrn(node.conceptIdentity))
              }

              return node;
            })
          );

          let reportAnnotations = null;
          if (state.isReportVisible) {
            const report = (metadataSet.reports || []).find(({id}) => id === state.reportId);
            reportAnnotations = report
              ? report.annotations
              : null;
          }

          const hasPermission = metadataSet && userPermissions && (
            !getDbIdAnnotationFromAnnotations(metadataSet, METADATA_SET_ID_ANNOTATION_ID) ||
            userPermissions.metadataflowOwner.includes(getStringFromArtefactTriplet(getMetadataflowTripletFromAnnotations(metadataSet)))
          );

          const reports = (metadataSet.reports || [])
            .map(report => ({
              ...report,
              isPublished: (report.annotations.find(({id}) => (id || "").toLowerCase() === REPORT_STATE_NAME_ANNOTATION_ID.toLowerCase()) || {}).text,
              targetId: report.target.id,
              targetReferenceValues: (report.target.referenceValues || []).map(({object}) => getTargetReferenceValuesStr(object)).join(", "),
              hasPermission: !(report.target.referenceValues || [])
                .map(({object}) => object)
                .filter(str => str.includes("urn:sdmx:"))
                .map(str => getArtefactTripletFromUrn(str))
                .find(({agencyID}) => userPermissions && !userPermissions.agencies.includes(agencyID))
            }))
            .filter(({isPublished}) => hasPermission ? true : isPublished === REPORT_STATE_PUBLISHED)

          return {
            ...state,
            metadataSet: {
              ...metadataSet,
              metadataflowTriplet: getMetadataflowTripletFromAnnotations(metadataSet),
              reports: [],
              categoryUrn: metadataSetNode.categoryUrn,
              type: metadataSetNode.type
            },
            hasPermission: hasPermission,
            reports: reports,
            msd: msd,
            isFetchMetadataSetDisabled: true,
            conceptSchemeTriplets: conceptSchemeTriplets,
            reportAnnotations: reportAnnotations
          };
        }
        case METADATA_SET_METADATAFLOWS_READ:
          let metadataflows = (getSdmxStructuresFromSdmxJson(action.response) || [])
            .map(artefact => getArtefactFromSdmxJsonStructure(artefact))
            .filter(({id, agencyID, version}) =>
              action.ownedMetadataflows.includes(getStringFromArtefactTriplet({id, agencyID, version})))
            .filter(({structure}) =>
              structure !== getCurrentNodeConfig(action).dcatapit.msd);

          return {
            ...state,
            metadataflows: metadataflows
          };
        case METADATA_SET_METADATA_SET_SUBMIT:
          return {
            ...state,
            categorySchemes: null,
            categorisations: null,
            categoryId: null,
            categoryUrn: null,
            metadataSets: null,
            metadataSetTree: null,
            metadataSet: null,
            conceptSchemeTriplets: null,
            isFetchMetadataSetDisabled: false,
            metadataSetId: action.metadataSetId,
            metadataSetCategory: action.metadataSetCategory,
            msdTriplet: action.msdTriplet
          };
        case METADATA_SET_METADATA_SET_CATEGORISE:
          return {
            ...state,
            categorySchemes: null,
            categorisations: null,
            categoryId: null,
            categoryUrn: null,
            metadataSets: null,
            metadataSetTree: null,
            metadataSet: null,
            conceptSchemeTriplets: null,
            isFetchMetadataSetDisabled: !action.metadataSetId,
            metadataSetId: action.metadataSetId,
            metadataSetCategory: action.metadataSetCategory,
            msdTriplet: action.msdTriplet
          };
        case METADATA_SET_METADATA_SET_DELETE:
          return {
            ...state,
            categorySchemes: null,
            categorisations: null,
            categoryId: null,
            categoryUrn: null,
            metadataSets: null,
            metadataSetTree: null,
            metadataSetId: state.metadataSetId === action.metadataSetId ? null : state.metadataSetId,
            metadataSetCategory: state.metadataSetId === action.metadataSetId ? null : state.metadataSetCategory,
            msdTriplet: state.metadataSetId === action.metadataSetId ? null : state.msdTriplet,
            metadataSet: null,
            conceptSchemeTriplets: null,
            isFetchMetadataSetDisabled: state.metadataSetId === action.metadataSetId
          };
        case METADATA_SET_REPORT_READ: {
          const metadataSet = getArtefactFromSdmxJsonStructure(getSdmxStructuresFromSdmxJson(action.response)[0]);
          const report = metadataSet.reports[0];

          const msdTree = _.cloneDeep(state.msdTree);
          let identifiableTargets = msdTree
            .find(msd => msd.target === report.target.id)
            .identifiableTargets
            .map(el => {
              const referenceValue = report.target.referenceValues.find(({id}) => id === el.id);
              return {
                ...el,
                value: referenceValue ? referenceValue.object : null
              }
            });

          return {
            ...state,
            report: {
              ...report,
              hasPermission: action.report.hasPermission,
              isPublished: action.report.isPublished
            },
            reportId: report.id,
            target: report.target.id,
            identifiableTargets: identifiableTargets,
            isReportVisible: true,
            step: REPORT_DETAILS_WIZARD_STEP_FIRST
          };
        }
        case METADATA_SET_REPORT_ATTRIBUTE_CODES_READ:
          return {
            ...state,
            codes: getItemSchemeFromSdmxJsonFactory(SDMX_JSON_CODELIST_ITEMS_KEY)(
              getSdmxStructuresFromSdmxJson(action.response)[0]).codes
          };
        case METADATA_SET_REPORT_TARGET_ARTEFACTS_READ:
          const userPermissions = getCurrentUserPermissions(action);
          return {
            ...state,
            artefacts: (getSdmxStructuresFromSdmxJson(action.response) || [])
              .map(artefact => getArtefactFromSdmxJsonStructure(artefact))
              .filter(({agencyID}) => userPermissions && userPermissions.agencies.find(agency => agency === agencyID))
          };
        case METADATA_SET_REPORT_SUBMIT: {
          return {
            ...state,
            isFetchMetadataSetDisabled: false
          }
        }
        case METADATA_SET_REPORT_DELETE:
          return {
            ...state,
            isFetchMetadataSetDisabled: false
          };
        case METADATA_SET_UPDATE_REPORT_STATE_SUBMIT:
          return {
            ...state,
            isFetchMetadataSetDisabled: false
          };
        case METADATA_SET_CONCEPT_SCHEMES_READ:
          const conceptSchemes = action.response.map(res =>
            getItemSchemeFromSdmxJsonFactory(SDMX_JSON_CONCEPT_SCHEME_ITEMS_KEY)(getSdmxStructuresFromSdmxJson(res)[0])
          );

          return {
            ...state,
            msdTree: getMsdTree(state.msd, conceptSchemes, action.appLang, action.dataLangs, getCurrentNodeConfig(action).annotations, getCurrentUserPermissions(action)),
            conceptSchemes: conceptSchemes
          };
        case METADATA_SET_METADATA_SET_CLONE_SUBMIT:
          return {
            ...state,
            categorySchemes: null,
            categorisations: null,
            categoryId: null,
            categoryUrn: null,
            metadataSets: null,
            metadataSetTree: null,
            metadataSet: null,
            conceptSchemeTriplets: null,
            isCloneVisible: false,
            cloneId: null,
            isFetchMetadataSetDisabled: false
          };
        case METADATA_SET_REPORT_ATTRIBUTE_ATTACHMENT_UPLOAD: {
          const reportStructure = _.cloneDeep(state.reportStructure);
          let selectedAttribute = getNode(reportStructure, "metadataAttributes", node =>
            node.nodeKey === state.selectedAttribute.nodeKey);

          selectedAttribute.attachmentUploaded[action.lang] = true;
          selectedAttribute.attachmentName[action.lang] = action.response;

          return {
            ...state,
            reportStructure: reportStructure,
            selectedAttribute: selectedAttribute
          };
        }
        case METADATA_SET_REPORT_CLONE_SUBMIT:
          return {
            ...state,
            isFetchMetadataSetDisabled: false
          };
        case METADATA_SET_IMPORT_REPORTS_FILE_UPLOAD: {
          return {
            ...state,
            uploadedFileHash: action.response.File,
            uploadedReports: (action.response.ReportItemResultList || []).map(report => {
              const userPermissions = getCurrentUserPermissions(action);
              const hasAgencyPermission = !(report.Target.referenceValues || [])
                .map(({object}) => object)
                .filter(str => str.includes("urn:sdmx:"))
                .map(str => getArtefactTripletFromUrn(str))
                .find(({agencyID}) => userPermissions && !userPermissions.agencies.includes(agencyID))
              let importable = report.Result;
              let message = report.Message;
              if (importable) {
                if (!hasAgencyPermission) {
                  importable = false;
                  message = AGENCY_PERMISSION_MISSING;
                }
              }
              return {
                ...report,
                importable: importable,
                Message: message,
                targetId: report.Target.id,
                targetReferenceValues: (report.Target.referenceValues || []).map(({object}) => getTargetReferenceValuesStr(object)).join(", ")
              }
            })
          }
        }
        case METADATA_SET_IMPORT_REPORTS_SUBMIT: {
          return {
            ...state,
            uploadedFileHash: null,
            uploadedReports: null,
            importedReports: action.response,
            isFetchMetadataSetDisabled: false
          }
        }
        default:
          return state;
      }
    case REQUEST_ERROR:
      switch (action.label) {
        case METADATA_SET_METADATA_SET_CATEGORISE:
          return metadataSetReducer(undefined, {});
        default:
          return state;
      }
    default:
      return state;
  }
};

export default metadataSetReducer;
